import { useState, useEffect } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export function useServiceDetail(slug) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setData(null);

    axios
      .get(`${BASE}/api/v1/services/${slug}`)
      .then((res) => {
        if (cancelled) return;
        const item = res.data?.data ?? res.data;
        if (item && item.slug) {
          setData(item);
        } else {
          setNotFound(true);
        }
      })
      .catch((err) => {
        if (cancelled) return;
        if (err?.response?.status === 404) {
          setNotFound(true);
        }
        // For network errors, leave data null → page uses built-in defaults
      })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [slug]);

  return { data, loading, notFound };
}
